import {formErrorAnatomy as parts} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers, cssVar, defineStyle} from '@chakra-ui/styled-system';
import {mode, getColorVar} from '@chakra-ui/theme-tools';

import {components as darkComponents} from '../../design-tokens/dark';
import {components} from '../../design-tokens/light';

const light = components.colors.components[`form-control`];
const dark = darkComponents.colors.components[`form-control`];

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(parts.keys);

const $fg = cssVar(`form-error-color`);

const baseStyleText = defineStyle(props => {
  const token = mode(light[`text-error`], dark[`text-error`])(props);

  return {
    [$fg.variable]: getColorVar(props.theme, token),
    color: $fg.reference,
    mt: `space-050`,
    fontSize: `fontSizes.sm`, // 12px
    lineHeight: `lineHeights.6`, // 24px
  };
});

const baseStyleIcon = defineStyle(props => {
  const token = mode(light[`icon-error`], dark[`icon-error`])(props);

  return {
    marginEnd: `0.5em`,
    [$fg.variable]: getColorVar(props.theme, token),
    color: $fg.reference,
  };
});

const baseStyle = definePartsStyle(props => ({
  text: baseStyleText(props),
  icon: baseStyleIcon(props),
}));

export const formErrorTheme = defineMultiStyleConfig({
  baseStyle,
});
